module.exports = __webpack_public_path__ + "img/slides-shape-2.d1c6c4e8.png";